(function () {
  'use strict';
// mitali
  var API_BASE = (window.NIJI_API_BASE || 'https://s.nijikart.com').replace(/\/$/, '');
  var root = document.querySelector('[data-seller-directory]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var grid = root.querySelector('#sellers-grid');
  var loader = root.querySelector('#sellers-loader');
  var notFound = root.querySelector('#sellers-not-found');
  var search = root.querySelector('[data-seller-search]');
  var meta = root.querySelector('[data-seller-meta]');
  var count = root.querySelector('[data-seller-count]');
  var sellers = [];

  loadAllProducts()
    .then(buildVendorList)
    .then(function (vendorList) {
      if (!vendorList.length) return [];
      return mapWithConcurrency(vendorList, 6, enrichSeller);
    })
    .then(function (vendorList) {
      sellers = vendorList.filter(Boolean).sort(function (a, b) {
        return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
      });
      setLoading(false);
      render(sellers);
    })
    .catch(function (error) {
      console.error('Seller directory could not be loaded:', error);
      setLoading(false);
      showEmpty(true);
    });

  if (search) {
    search.addEventListener('input', function () {
      var query = normalizeText(search.value);
      var filtered = sellers.filter(function (seller) {
        return normalizeText([seller.name, seller.vendor, seller.bio, seller.location].join(' ')).indexOf(query) !== -1;
      });
      render(filtered);
    });
  }

  function loadAllProducts() {
    var allProducts = [];
    var page = 1;
    var pageSize = 250;
    var maximumPages = 40;

    function next() {
      return fetch('/collections/all/products.json?limit=' + pageSize + '&page=' + page, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Shopify products request failed: ' + response.status);
          return response.json();
        })
        .then(function (payload) {
          var batch = Array.isArray(payload.products) ? payload.products : [];
          allProducts = allProducts.concat(batch);
          page += 1;
          if (batch.length === pageSize && page <= maximumPages) return next();
          return allProducts;
        });
    }

    return next();
  }

  function buildVendorList(products) {
    var unique = Object.create(null);

    products.forEach(function (product) {
      var vendor = String(product.vendor || '').trim();
      if (!vendor) return;
      var key = vendor.toLowerCase();
      if (!unique[key]) {
        unique[key] = {
          vendor: vendor,
          name: vendor,
          slug: sellerSlug(vendor),
          bio: '',
          location: '',
          logo: '',
          profileImage: '',
          verified: false
        };
      }
    });

    return Object.keys(unique).map(function (key) { return unique[key]; });
  }

  function enrichSeller(seller) {
    if (!seller.slug) return Promise.resolve(seller);

    return fetch(API_BASE + '/api/sellers/' + encodeURIComponent(seller.slug) + '/', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (payload) {
        var profile = payload && (payload.seller || payload.data || payload);
        if (!profile) return seller;

        seller.name = clean(profile.display_name || profile.seller_shop_name || profile.shop_name || seller.vendor);
        seller.slug = sellerSlug(profile.storefront_subdomain || profile.slug || seller.slug);
        seller.bio = clean(profile.short_store_description || profile.bio || profile.store_description || '');
        seller.location = clean(profile.location || [profile.store_city, profile.store_country].filter(Boolean).join(', '));

        // The uploaded shop logo is a distinct backend field. Profile image is only
        // a secondary fallback; initials are rendered when neither image is usable.
        seller.logo = absoluteMediaUrl(profile.shop_logo_url || profile.logo_url || '');
        seller.profileImage = absoluteMediaUrl(profile.profile_image_url || profile.avatar_url || '');
        seller.verified = Boolean(profile.verified || profile.is_verified);
        return seller;
      })
      .catch(function () { return seller; });
  }

  function render(list) {
    if (!grid) return;
    showEmpty(list.length === 0);
    grid.hidden = list.length === 0;

    if (count) count.textContent = String(list.length);
    if (meta) meta.hidden = sellers.length === 0;

    grid.innerHTML = list.map(cardMarkup).join('');

    Array.prototype.forEach.call(grid.querySelectorAll('[data-seller-logo]'), function (image) {
      image.addEventListener('error', function handleError() {
        var secondary = image.getAttribute('data-secondary-logo');
        if (secondary && image.src !== secondary) {
          image.setAttribute('data-secondary-logo', '');
          image.src = secondary;
          return;
        }
        var fallback = image.nextElementSibling;
        image.hidden = true;
        if (fallback) fallback.hidden = false;
      });
    });
  }

  function cardMarkup(seller) {
    var initials = sellerInitials(seller.name);
    var primaryImage = seller.logo || seller.profileImage;
    var secondaryImage = seller.logo && seller.profileImage && seller.logo !== seller.profileImage ? seller.profileImage : '';
    var url = '/pages/seller?v=' + encodeURIComponent(seller.slug);
    var bioClass = seller.bio ? 'seller-card__bio' : 'seller-card__bio seller-card__bio--empty';
    var logoMarkup = '';

    if (primaryImage) {
      logoMarkup += '<img class="seller-card__avatar" data-seller-logo src="' + escapeAttribute(primaryImage)
        + '" data-secondary-logo="' + escapeAttribute(secondaryImage) + '" alt="' + escapeAttribute(seller.name + ' shop logo') + '" loading="lazy">';
      logoMarkup += '<span class="seller-card__initials" hidden aria-hidden="true">' + escapeHtml(initials) + '</span>';
    } else {
      logoMarkup = '<span class="seller-card__initials" aria-hidden="true">' + escapeHtml(initials) + '</span>';
    }

    return '<a class="seller-card" href="' + escapeAttribute(url) + '" aria-label="View ' + escapeAttribute(seller.name) + ' store">'
      + '<div class="seller-card__content">'
      + '<div class="seller-card__avatar-wrap">' + logoMarkup
      + (seller.verified ? '<span class="seller-card__verified" title="Verified seller" aria-label="Verified seller">✓</span>' : '')
      + '</div>'
      + '<h2 class="seller-card__name">' + escapeHtml(seller.name) + '</h2>'
      + (seller.location ? '<p class="seller-card__location">' + escapeHtml(seller.location) + '</p>' : '')
      + '<p class="' + bioClass + '">' + escapeHtml(seller.bio || 'Seller description') + '</p>'
      + '<span class="seller-card__cta">View store <span class="seller-card__arrow" aria-hidden="true">→</span></span>'
      + '</div></a>';
  }

  function setLoading(isLoading) {
    if (loader) loader.hidden = !isLoading;
  }

  function showEmpty(show) {
    if (notFound) notFound.hidden = !show;
  }

  function mapWithConcurrency(items, limit, mapper) {
    var output = new Array(items.length);
    var cursor = 0;

    function worker() {
      var index = cursor++;
      if (index >= items.length) return Promise.resolve();
      return Promise.resolve(mapper(items[index], index))
        .then(function (value) { output[index] = value; })
        .then(worker);
    }

    var workers = [];
    for (var i = 0; i < Math.min(limit, items.length); i += 1) workers.push(worker());
    return Promise.all(workers).then(function () { return output; });
  }

  function sellerSlug(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function sellerInitials(value) {
    var words = String(value || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return 'S';
    return words.slice(0, 2).map(function (word) { return word.charAt(0); }).join('').toUpperCase();
  }

  function absoluteMediaUrl(value) {
    var url = clean(value);
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (/^https?:\/\//i.test(url) || /^data:/i.test(url)) return url;
    return API_BASE + (url.charAt(0) === '/' ? url : '/' + url);
  }

  function clean(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeText(value) {
    return clean(value).toLowerCase();
  }

  function escapeHtml(value) {
    return clean(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }
})();
